import { Space } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import React from 'react';

import type { OutsourcedVendor } from '@/types/database/outsourcedVendor';

import DeleteVendor from '../components/DeleteVendor';
import EditVendor from '../components/EditVendor';

export const getColumns = (updateVendors: () => void) => {
  const FORMATTER = 'YYYY-MM-DD HH:mm:ss';

  const columns: ColumnsType<OutsourcedVendor> = [
    {
      key: 'createdTime',
      dataIndex: 'createdTime',
      title: '建立時間',
      render: (value) => moment(value).format(FORMATTER),
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '廠商名稱',
    },
    {
      key: 'phone',
      dataIndex: 'phone',
      title: '廠商電話',
    },
    {
      key: 'contactPerson',
      dataIndex: 'contactPerson',
      title: '聯繫窗口名稱',
    },
    {
      key: 'updatedTime',
      dataIndex: 'updatedTime',
      title: '更新時間',
      render: (value) => moment(value).format(FORMATTER),
    },
    {
      dataIndex: '_id',
      key: 'action',
      title: '操作',
      render: (value, record) => (
        <Space>
          <EditVendor
            buttonLabel="編輯"
            editVendor={record}
            updateVendors={updateVendors}
          />
          <DeleteVendor vendorId={value} updateVendors={updateVendors} />
        </Space>
      ),
    },
  ];

  return columns;
};

export const getInitialValues = (editVendor?: OutsourcedVendor) => {
  if (!editVendor) {
    return {
      name: '',
      phone: '',
      contactPerson: '',
    };
  }

  return {
    name: editVendor.name,
    phone: editVendor.phone,
    contactPerson: editVendor.contactPerson,
  };
};
